import moment from 'moment';
import axiosClient, { HOST } from './axiosClient';
import { getCurrentConfig, getCurrentTreeDataJson } from '../components/familytree/scripts/cy-core';
import { saveDataEncrypted, getDBData } from '../components/familytree/scripts/aws-dynamo';
import { simpleEncode } from '../components/familytree/scripts/aws-kms';

const treeService = {
  getTreeData: (params) => getData(params),
  getTreeDetail: (code) => axiosClient.get(`${HOST.PRODUCT_SERVICE}/product/bank/${code}`),
  getMetaData: (params) => axiosClient.get(`${HOST.PRODUCT_SERVICE}/product/metadata`, { params }),
  changeTreeStatus: (data) =>
    axiosClient.put(`${HOST.PRODUCT_SERVICE}/product/bank/updateStatus/${data.id}`, {
      status: data.status,
    }),
  createTree: (data) => axiosClient.post(`${HOST.PRODUCT_SERVICE}/product/create-bank`, data),
  updateTree: async (payload) => {
    const { userId, callback } = payload;
    // // debug-console.log('update Tree: ' + userId);
    const treeData = getCurrentTreeDataJson();
    const config = getCurrentConfig();
    // const userData = { config, data };
    // // debug-console.log('update Tree: userData=', userData);
    const treeDataText = JSON.stringify(treeData);

    // We can choose a way to secure transferring data
    // 1. AWS KMS:
    // const encryptedObj = await encryptKMS(userDataText);
    // save DataEncrypted(encryptedObj.CiphertextBlob, userId, callback);
    // 2. Encode to Base64:
    const base64Text = simpleEncode(treeDataText);
    saveDataEncrypted(config, base64Text, userId, callback);
    // 3. No encryption:
    // saveItem(userDataText, userId, callback);
  },
  exportData: (params) =>
    axiosClient
      .get(`${HOST.PRODUCT_SERVICE}/product/banks/export`, {
        params,
        responseType: 'blob',
      })
      .then((res) => {
        const currentDate = moment(new Date()).format('DDMMYYYY');
        const urll = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = urll;
        link.setAttribute('download', `Tree_${currentDate}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        if (error.response) {
          return Promise.reject(error.response);
        }
        return Promise.reject(error);
      }),
};

const getData = async (payload) => {
  const { userId, callback } = payload;
  // debug-console.log('Start get: ' + userId);
  getDBData(userId, callback);
};

export default treeService;
